module.exports = __webpack_public_path__ + "_assets/img/Frame1212.e8c0c603.svg";